import axios from "axios";
import { AbstractWidgetSettings } from "../components/ConfigurationPage/widgetsettings/AbstractWidgetSettings";
import { HistoryWidgetSettings } from "../pages/History/HistoryWidgetSettings";
import { action, makeObservable, observable } from "mobx";
import { WidgetStore } from "../stores/WidgetStore";
import { PlayerPopupWidgetSettings } from "../components/ConfigurationPage/widgetsettings/PlayerPopupWidgetSettings";
import { MediaWidgetSettings } from "../components/ConfigurationPage/widgetsettings/MediaWidgetSettings";
import { PlayerInfoWidgetSettings } from "../components/ConfigurationPage/widgetsettings/PlayerInfoWidgetSettings";
import { DonatersTopListWidgetSettings } from "../components/ConfigurationPage/widgetsettings/DonatersTopListWidgetSettings";
import { DonationTimerWidgetSettings } from "../components/ConfigurationPage/widgetsettings/DonationTimerWidgetSettings";
import { DonationGoalWidgetSettings } from "../components/ConfigurationPage/widgetsettings/DonationGoalWidgetSettings";
import { PaymentAlertsWidgetSettings } from "../components/ConfigurationPage/widgetsettings/alerts/PaymentAlertsWidgetSettings";
import { PlayerControlWidgetSettings } from "../components/ConfigurationPage/widgetsettings/PlayerControlWidgetSettings";
import { DonatonWidgetSettings } from "../components/ConfigurationPage/widgetsettings/donaton/DonatonWidgetSettings";
import { RutonyChatSettings } from "../pages/RutonyChat/RutonyChatSettings";
import { tokenRequest } from "../pages/Login/Login";
import { HorizontalEventsWidgetSettings } from "../pages/HorizontalEvents/HorizontalEventsWidgetSettings";
import { ReactNode, createContext } from "react";
import AlertsIcon from "../icons/widgets/AlertsIcon";
import { RouletteWidgetSettings } from "../pages/Roulette/RouletteWidgetSettings";
import DonationGoalIcon from "../icons/DonationGoalIcon";
import TopListIcon from "../icons/widgets/TopListIcon";
import SongIcon from "../icons/SongIcon";
import HistoryIcon from "../icons/HistoryIcon";
import InfoIcon from "../icons/InfoIcon";
import ClockIcon from "../icons/widgets/ClockIcon";
import HourglassIcon from "../icons/widgets/HourglassIcon";
import ReelIcon from "../icons/ReelIcon";
import VideoIcon from "../icons/widgets/VideoIcon";
import IntegrationIcon from "../icons/IntegrationIcon";
import EventFeedIcon from "../icons/widgets/EventFeedIcon";
import RouletteIcon from "../icons/widgets/RouletteIcon";
import { ReelWidgetSettings } from "../pages/Reel/ReelWidgetSettings";
import { StreamCreditsWidgetSettings } from "../pages/StreamCredits/StreamCreditsWidgetSettings";
import { AuctionWidgetSettings } from "../pages/AuctionWidget/AuctionWidgetSettings";
import { CanvasWidgetSettings } from "../components/ConfigurationPage/widgetsettings/canvas/CanvasWidgetSettings";
import { CustomWidgetSettings } from "../pages/CustomWidget/CustomWidgetSettings";
import { ChatWidgetSettings } from "../pages/ChatWidget/ChatWidgetSettings";
import { EmoteWallWidgetSettings } from "../pages/EmoteWall/EmoteWallWidgetSettings";

export const WIDGET_TYPES = [
  {
    name: "payment-alerts",
    title: "Оповещения/Алерты",
    icon: <AlertsIcon />,
    category: "onscreen",
    preview: "https://api.oda.digital/assets/alert.png",
    description: "Показывает оповещения о получаемых донатах.",
    create: () => new PaymentAlertsWidgetSettings(),
  },
  {
    name: "donationgoal",
    title: "Цели сбора",
    icon: <DonationGoalIcon />,
    category: "onscreen",
    preview: "https://api.oda.digital/assets/donationgoal.png",
    description:
      "Позволяет задать цели сбора донатов. При добавлении виджета и добавлении в нем целей, они отображаются на странице доната и доступны для выбора, а сам виджет можно показать на стриме и отслеживать прогресс.",
    create: () => new DonationGoalWidgetSettings(),
  },
  {
    name: "donaters-top-list",
    title: "Список донатеров",
    icon: <TopListIcon />,
    category: "onscreen",
    preview: "https://api.oda.digital/assets/toplist.png",
    description:
      "Отображает список или топ-донатеров или последних донатеров за промежуток времени (день, месяц)",
    create: () => new DonatersTopListWidgetSettings(),
  },
  {
    name: "media",
    title: "Медиаплеер",
    icon: <SongIcon />,
    preview: "https://api.oda.digital/assets/mediaplayer.png",
    category: "media",
    description:
      "Позволяет воспроизвести реквесты (музыки) из донатов. Поддерживается YouTube и VKVideo. Если реквестов нет, можно в плеере включить свой плейлист из YouTube - если будет реквест в донате, плеер автоматически переключится на него, а потом обратно на свой плейлист.",
    create: () => {
      return new MediaWidgetSettings();
    },
  },
  {
    name: "payments",
    title: "События",
    icon: <HistoryIcon color="var(--oda-color-1000)" />,
    category: "internal",
    preview: "https://api.oda.digital/assets/payments.png",
    description:
      "Показывает список донатов, обновляется в реальном времени. Также есть кнопки для прерывания/повтора алерта на стриме.",
    create: () => new HistoryWidgetSettings(),
  },
  {
    name: "donation-timer",
    title: "Счётчик времени без поддержки",
    icon: <ClockIcon />,
    category: "onscreen",
    preview: "https://api.oda.digital/assets/donationtimer.png",
    description:
      "Отображает время прошедшее после последней поддержки. Обновляется в реальном времени.",
    create: () => new DonationTimerWidgetSettings(),
  },
  {
    name: "player-info",
    title: "Информация из медиаплеера",
    icon: <InfoIcon />,
    category: "media",
    preview: "https://api.oda.digital/assets/playerinfo.png",
    description:
      "Выводит информацию для медиаплеера: название и количество заказов в очереди",
    create: () => new PlayerInfoWidgetSettings(),
  },
  {
    name: "donaton",
    title: "Таймер до конца трансляции",
    icon: <HourglassIcon />,
    category: "onscreen",
    preview: "https://api.oda.digital/assets/donaton.png",
    description:
      "Выводит таймер до конца трансляции. Донаты увеличивают время таймера. Подходит для донатофонов",
    create: () => new DonatonWidgetSettings(),
  },
  {
    name: "horizontal-events",
    title: "Горизонтальная лента событий",
    icon: <EventFeedIcon />,
    category: "onscreen",
    preview: "",
    description:
      "Бегущая строка, показывающая последние события (донаты в текущий момент)",
    create: () => new HorizontalEventsWidgetSettings(),
  },
  {
    name: "reel",
    title: "Рулетка",
    icon: <ReelIcon />,
    category: "onscreen",
    preview: "",
    description:
      "Позволяет создать рулетку с призами. За поддержку рулетка будет прокручиваться, рандомно выбирая слоты",
    create: () => new ReelWidgetSettings(),
  },
  {
    name: "player-popup",
    title: "Видео из медиаплеера",
    icon: <VideoIcon />,
    category: "media",
    preview: "https://api.oda.digital/assets/popup.png",
    description: "Показывает видео из заказанных медиа в медиаплеере",
    create: () => {
      return new PlayerPopupWidgetSettings();
    },
  },
  {
    name: "rutonychat",
    title: "Интеграция с Rutony Chat",
    icon: <IntegrationIcon />,
    category: "internal",
    preview: "",
    description: "Rutony Chat Integration",
    create: () => new RutonyChatSettings(),
  },
  {
    name: "player-control",
    title: "Пульт от медиаплеера",
    icon: <span className="material-symbols-sharp">settings_remote</span>,
    category: "media",
    preview: "",
    description: "Позволяет удалённо управлять медиаплеером",
    create: () => new PlayerControlWidgetSettings(),
  },
  {
    name: "roulette",
    title: "Рулетка (Колесо)",
    icon: <RouletteIcon />,
    category: "onscreen",
    preview: "",
    description:
      "Позволяет создать рулетку с призами. За поддержку рулетка будет прокручиваться, рандомно выбирая слоты",
    create: () => new RouletteWidgetSettings(),
  },
  {
    name: "action-queue",
    title: "Заказ действий",
    icon: <span className="material-symbols-sharp">pending_actions</span>,
    category: "onscreen",
    preview: "",
    description:
      "Позволяет задать и управлять действиями, которые донатер может 'заказать' на стриме",
    create: () => new RouletteWidgetSettings(),
  },
  {
    name: "stream-credits",
    title: "Титры",
    icon: <span className="material-symbols-sharp">pending_actions</span>,
    category: "onscreen",
    preview: "",
    description: "Виджет со статистикой для показа в конце стрима как титры",
    create: () => new StreamCreditsWidgetSettings(),
  },
  {
    name: "auction",
    title: "Аукцион",
    icon: <span className="material-symbols-sharp">gavel</span>,
    category: "onscreen",
    preview: "",
    description:
      "Виджет позволяет разыгрывать что-то, крутя колесо. Слоты автоматически добавляются из донатов.",
    create: () => new AuctionWidgetSettings(),
  },
  {
    name: "canvas",
    title: "Холст",
    icon: <span className="material-symbols-sharp">dashboard</span>,
    category: "onscreen",
    preview: "",
    description: "Виджет для группировки других виджетов внутри себя.",
    create: () => new CanvasWidgetSettings(),
  },
  {
    name: "custom",
    title: "Custom/Импорт из StreamElements",
    icon: <span className="material-symbols-sharp">tools_power_drill</span>,
    category: "onscreen",
    preview: "",
    description:
      "Виджет, поддерживающий кастомные виджеты в формате StreamElements",
    create: () => new CustomWidgetSettings(),
  },
  {
    name: "chat",
    title: "Чат",
    icon: <span className="material-symbols-sharp">forum</span>,
    category: "onscreen",
    preview: "",
    description:
      "Виджет, отображающий общий чат с площадок Twitch, VKLive, Kick. Усиленно кеширует смайлы при включении.",
    create: () => new ChatWidgetSettings(),
  },
  {
    name: "emote-wall",
    title: "Стена эмоций",
    icon: (
      <span className="material-symbols-sharp">sentiment_very_satisfied</span>
    ),
    category: "onscreen",
    preview: "",
    description:
      "Виджет, отображающий летящие эмоции из чата поверх стрима. Поддерживает как смайлы платформ (Twitch, VKLive, Kick), так и  7tv.",
    create: () => new EmoteWallWidgetSettings(),
  },
];

interface SavedProperty {
  name: string;
  value: any;
}

// TODO: use decorators
export class Widget {
  private _id: string;
  private _type: string;
  private _sortOrder: number;
  private _name: string;
  private _ownerId: string;
  private _config: AbstractWidgetSettings;
  private _store: WidgetStore;
  private _icon: ReactNode;
  private _enabled: boolean;

  constructor(params: {
    id: string;
    type: string;
    sortOrder: number;
    name: string;
    ownerId: string;
    enabled: boolean;
    icon: ReactNode;
    config: AbstractWidgetSettings;
    store: WidgetStore;
  }) {
    this._id = params.id;
    this._type = params.type;
    this._sortOrder = params.sortOrder;
    this._name = params.name;
    this._ownerId = params.ownerId;
    this._config = params.config;
    this._store = params.store;
    this._icon = params.icon;
    this._enabled = params.enabled;
    makeObservable<Widget, "_name" | "_config" | "_enabled">(this, {
      _name: observable,
      _config: observable,
      _enabled: observable,
      reload: action,
    });
  }

  public static createDefault(
    type: string,
  ): AbstractWidgetSettings | undefined {
    return WIDGET_TYPES.find((t) => t.name === type)?.create();
  }

  public static configFromJson(json: any): AbstractWidgetSettings | null {
    return this.config(json.type, json.config?.properties ?? []);
  }

  public static config(
    type: string,
    properties: SavedProperty[],
  ): AbstractWidgetSettings | null {
    const settings = this.createDefault(type);
    if (settings === undefined) {
      return null;
    }
    properties.forEach((prop) => {
      settings.set(prop.name, prop.value, true);
    });
    return settings;
  }

  public static fromJson(json: any, store: WidgetStore): Widget | null {
    if (json.id === undefined) {
      return null;
    }
    if (json.type === undefined) {
      return null;
    }
    if (json.sortOrder === undefined) {
      return null;
    }
    if (json.name === undefined) {
      return null;
    }
    if (json.ownerId === undefined) {
      return null;
    }
    return new Widget({
      id: json.id,
      type: json.type,
      sortOrder: json.sortOrder,
      name: json.name,
      ownerId: json.ownerId,
      enabled:
        json.enabled === null || json.enabled === undefined
          ? true
          : json.enabled,
      icon: WIDGET_TYPES.filter((type) => type.name === json.type).at(0)
        ?.icon ?? <></>,
      config:
        this.configFromJson(json) ||
        new AbstractWidgetSettings({ sections: [] }),
      store: store,
    });
  }

  public copy(): Promise<Widget | null> {
    return this._store.addWidget(this.type).then((widget) => {
      if (widget) {
        widget.setConfig(this.config.copy());
      }
      return widget;
    });
  }

  private setConfig(config: AbstractWidgetSettings) {
    this._config = config;
  }

  public async reload(): Promise<void> {
    await axios
      .get(`${process.env.REACT_APP_WIDGET_API_ENDPOINT}/widgets/${this._id}`)
      .then((response) => {
        this.setConfig(
          Widget.configFromJson(response.data) ||
            new AbstractWidgetSettings({ sections: [] }),
        );
      });
  }

  public async rename(name: string): Promise<void> {
    const request = {
      name: name,
    };
    await axios.patch(
      `${process.env.REACT_APP_WIDGET_API_ENDPOINT}/widgets/${this._id}`,
      request,
    );
    this.name = name;
  }

  public async save(): Promise<void> {
    const properties = await this._config.prepareConfig();
    const request = {
      name: this._name,
      config: {
        properties: properties,
      },
    };
    await axios
      .patch(
        `${process.env.REACT_APP_WIDGET_API_ENDPOINT}/widgets/${this._id}`,
        request,
      )
      .then(() => {
        this.config.markSaved();
      });
  }

  async url() {
    const tokens = await tokenRequest({
      refreshToken: localStorage.getItem("refresh-token") ?? "",
    });
    navigator.clipboard.writeText(
      `${process.env.REACT_APP_ENDPOINT}/${this._type}/${this._id}?refresh-token=${tokens.refreshToken}`,
    );
  }
  async delete(): Promise<void> {
    await this._store.deleteWidget(this._id);
  }
  public get id(): string {
    return this._id;
  }
  public get type(): string {
    return this._type;
  }
  public get sortOrder(): number {
    return this._sortOrder;
  }
  public get name(): string {
    return this._name;
  }
  public set name(name: string) {
    this._name = name;
  }
  public get ownerId(): string {
    return this._ownerId;
  }
  public get icon(): ReactNode {
    return this._icon;
  }
  public get enabled(): boolean {
    return this._enabled;
  }
  public toggle(): void {
    this._store.toggleWidget(this._id);
    this._enabled = !this._enabled;
  }
  public get config(): AbstractWidgetSettings {
    return this._config;
  }
  public get subactions(): ReactNode {
    return this._config.subactions(this._id);
  }
}

export const WidgetContext = createContext<Widget | null>(null);
